/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Step_RegisterInputs */

const en_directory_agents_step_register = /** @type {(inputs: Directory_Agents_Step_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registers the deployed product and starts an authorization claim.`)
};

const zh_directory_agents_step_register = /** @type {(inputs: Directory_Agents_Step_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册已部署的产品，发起一次授权请求（claim）。`)
};

/**
* | output |
* | --- |
* | "Registers the deployed product and starts an authorization claim." |
*
* @param {Directory_Agents_Step_RegisterInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_step_register = /** @type {((inputs?: Directory_Agents_Step_RegisterInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Step_RegisterInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_step_register(inputs)
	return zh_directory_agents_step_register(inputs)
});
export { directory_agents_step_register as "directory.agents.step_register" }